module.exports = __webpack_public_path__ + "static/media/badge-gold.cf8f076d.png";